import { render, staticRenderFns } from "./SignUpPhone.vue?vue&type=template&id=034b8250&"
import script from "./SignUpPhone.vue?vue&type=script&lang=ts&"
export * from "./SignUpPhone.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports